import Choices from "choices.js";

export default class Glossary {
    constructor() {
        console.log('%c👍🏼 Glossary', 'color: yellow');
        this.glossary = document.querySelector('.glossary');
        
    }
    init() {

        let glossaryScroll = document.querySelectorAll('.glossary-scroll');

        glossaryScroll.forEach((item) => {

            item.addEventListener('click', function (e) {

                e.preventDefault();

                let headerOffset = 145;

                let glossaryNextEl = document.querySelector(this.getAttribute("href")).offsetTop;

                console.log(glossaryNextEl);

                let glossaryNextElOffsetPosition = glossaryNextEl - headerOffset;

                console.log(glossaryNextElOffsetPosition);
            
                window.scrollTo({
                    top: glossaryNextElOffsetPosition,
                    behavior: "smooth"
                });
            });
        });

        let languageSelect = document.querySelector('#language');

        if(languageSelect) {
            new Choices(languageSelect, {
                searchEnabled: false,
                itemSelectText: '',
                placeholder: true,
                placeholderValue: 'Select Language',
                allowHTML: false
                // labelId: languageSelect.id + '-label'
            });
    
            languageSelect.addEventListener('choice', (event) => {  
                window.location.href = event.detail.choice.value;
            });
        }
       
        let input = document.querySelector('#glossary-search');
        const glossaryTitles = document.querySelectorAll('.glossary h2');
        input.addEventListener('keyup', function(event){
            let searchString = event.target.value;
            glossaryTitles.forEach((term) => {
                
                let foundMatchForLetter = false;
                let termDefinition = term.nextElementSibling; 
               
                while (termDefinition && termDefinition.classList && termDefinition.classList.contains('definition')) {
                    if (termDefinition.innerText.toLowerCase().includes(searchString.toLowerCase())){
                        foundMatchForLetter = true;
                        termDefinition.classList.remove('hide');
                    } else {
                        termDefinition.classList.add('hide');
                    }

                    termDefinition = termDefinition.nextElementSibling;
                    
                    if (!foundMatchForLetter) {
                        term.classList.add('hide');
                    } else {
                        term.classList.remove('hide');
                    }
                }
                
            });
        });
    }
}